import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "auto",
    },
    container: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(0),
        padding: theme.spacing(2),
      },
    },
    bigTitle: {
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    listItem: {
      // width: '40%',

      "& .MuiListItemIcon-root": {
        minWidth: "0px !important",
      },
      padding: 0,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    rowContainer: {
      flexWrap: "nowrap",
      width: "40%",
      gap: 15,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        flexDirection: "column",
      },
    },
    item: {
      width: "100%",
      "& .MuiFormLabel-root": {
        color: "black",
      },

      "& input[type='file']": {
        color: "transparent",
        // display: 'none !important',
      },
      [theme.breakpoints.down("sm")]: {
        flex: 12,
        width: "100% !important",
      },
    },

    input: {
      width: "100%",
      fontSize: theme.spacing(1),
      "& .MuiInput-underline:after": {
        borderColor: "#D5D8DF",
      },
      "& .MuiInput-underline:before": {
        borderColor: "#D5D8DF",
      },
    },
    steps: {
      fontWeight: 400,
      fontSize: theme.spacing(1),
    },
    button: {
      marginTop: theme.spacing(4),
      marginLeft: 0,
      borderRadius: "40px !important",
      justifyContent: "space-between",
      height: 40,
      fontWeight: 700,
      fontStyle: "normal",
      fontSize: theme.spacing(1.5),
      letterSpacing: "0.8px",
      [theme.breakpoints.down("sm")]: {
        flex: 12,
        width: "100%",
      },
    },
  })
);
